import { render, staticRenderFns } from "./dayTrade.vue?vue&type=template&id=049509c0&scoped=true&"
import script from "./dayTrade.vue?vue&type=script&lang=js&"
export * from "./dayTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049509c0",
  null
  
)

export default component.exports